import axios from "axios";
import { FormTemplate, Report } from "../types/Rows";
import { ApiURI } from "../types/configs";
import { headers } from "./headers";

export const CentralMonitoringInstance = axios.create({
  baseURL: ApiURI + "CentralMonitoring/",
});

// Get central monitoring template for a study
export const getCentralMonitoringTemplate = async (studyId: string) => {
  return (await CentralMonitoringInstance.get<FormTemplate>(
    `${studyId}/template`,
    headers()
  )).data;
};

// Create central monitoring template for a study
export const createCentralMonitoringTemplate = async (studyId: string) => {
  return await CentralMonitoringInstance.post<FormTemplate>(
    `${studyId}/template`,
    {},
    headers()
  );
};

// Create central monitoring report for a study
export const createCentralMonitoringReport = async (studyId: string) => {
  return (await CentralMonitoringInstance.post<{ id: string; name: string }>(
    `${studyId}/reports`,
    {},
    headers()
  )).data;
};

// Get all central monitoring reports for a study
export const getCentralMonitoringReports = async (studyId: string) => {
  return (await CentralMonitoringInstance.get<Report[]>(
    `${studyId}/reports`,
    headers()
  )).data;
};